module.exports = __webpack_public_path__ + "img/analysisTabs-second-false.9d112742.png";